import styles from '@styles/scss/performer/_similarModelGrid.module.scss';
import { PerformerCard } from 'lib/types/item/performerCard';
import { PerformerPage } from 'lib/types/item/performerPage';
import { useEffect, useState } from 'react';

import Card from './card';

export default function SimilarModelGrid({
    performerCards,
    currentLang,
    performerPage,
    gender
}: {
    performerCards: PerformerCard[];
    currentLang: string;
    performerPage: PerformerPage;
    gender: string;
}): JSX.Element {
    const [hovered, setHovered] = useState<number | null>(null);

    const handleHover = (index: number) => setHovered(index);
    const handleUnhover = () => setHovered(null);

    const onlinePerformers = performerCards.filter(performer => performer.is_online !== null);
    return (
        <div className={styles.performerContainer}>
            <p>{performerPage.similar_sex_cams}</p>
            <div className={styles.performers}>
                {onlinePerformers.map((performer, index) => (
                    <div
                        key={performer.username}
                        className={styles.performer}
                        onMouseEnter={() => handleHover(index)}
                        onMouseLeave={handleUnhover}
                        onTouchStart={() => handleHover(index)}
                        onTouchEnd={handleUnhover}
                        >
                        <Card
                            key={performer.username}
                            performerCard={performer}
                            currentLang={currentLang}
                            gender={gender}
                            randomNumber={15}
                            index={index}
                            currentlyHovered={hovered === index}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}
